import React from "react";
import "./index.css";

import { Card, Divider, Statistic, Col, Row } from "antd";
import { capitalizeTitleCase } from "../../../utils/utility";

const DashboardOpenCloseWidget = ({ label, dailyTurnOver, openTables }) => {
  const { openCount, openTotalTurnOver, closedCount, closedTotalTurnOver } =
    openTables;

  const data = [
    {
      title: "Отворени",
      count: openCount,
      total: openTotalTurnOver,
    },
    {
      title: "Затворени",
      count: closedCount,
      total: closedTotalTurnOver,
    },
  ];

  return (
    <div>
      <div className="dashboard-open-close-widget-container">
        <Card
          className="dashboard-open-close-widget-card"
          title={label}
          bodyStyle={{ paddingTop: 0, paddingBottom: 0 }}
          headStyle={{ fontSize: "24px" }}
        >
          {data[0].count !== undefined && (
            <Row gutter={16} style={{ margin: "15px auto" }}>
              <Col span={12} className="dashboard-open-close-col">
                <Statistic
                  valueStyle={{ fontSize: "20px" }}
                  title={data[0].title}
                  value={`${data[0].count} / ${data[0].total?.toFixed(2)} €`}
                />
              </Col>
              <Col span={12} className="dashboard-open-close-col">
                <Statistic
                  valueStyle={{ fontSize: "20px" }}
                  title={data[1].title}
                  value={`${data[1].count} / ${data[1].total?.toFixed(2)} €`}
                />
              </Col>
            </Row>
          )}
          <Divider className="dashboard-open-close-widget-divider" />

          {dailyTurnOver.length !== 0 && (
            <div>
              {dailyTurnOver.map(
                (item, index) =>
                  index % 2 === 0 && (
                    <Row
                      key={index}
                      gutter={16}
                      style={{ margin: "25px auto" }}
                    >
                      <Col span={12} className="dashboard-open-close-col">
                        <Statistic
                          valueStyle={{ fontSize: "20px" }}
                          title={capitalizeTitleCase(item.paymentName)}
                          value={`${item.sum?.toFixed(2)} €`}
                        />
                      </Col>
                      {index + 1 < dailyTurnOver.length && (
                        <Col span={12} className="dashboard-open-close-col">
                          <Statistic
                            valueStyle={{ fontSize: "20px" }}
                            title={capitalizeTitleCase(
                              dailyTurnOver[index + 1].paymentName
                            )}
                            value={`${dailyTurnOver[index + 1].sum?.toFixed(
                              2
                            )} €`}
                          />
                        </Col>
                      )}
                    </Row>
                  )
              )}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default DashboardOpenCloseWidget;
